import { useState, useRef, useEffect } from "react"
import { useGlobalState } from "@biolumina/ui/context/globalStateProvider"
export const useScrollspy = (targetIds = [], {
  root = () => window.document.querySelector('#__next'),
} = {}) => {
  const [
    currentIntersectingElementIndex,
    setCurrentIntersectingElementIndex,
  ] = useState(-1)

  const { setScrollSpyIndex, scrollMargin: offset } = useGlobalState()

  const rootMargin = `-${(offset) || 0}px 0px 0px 0px`
  const observer = useRef()

  useEffect(() => {
    if (observer.current) {
      observer.current.disconnect()
    }
    
    observer.current = new IntersectionObserver(
      //with multipe intersections, 
      (entries) => {
        const status = []
        const intersections = []
        entries.forEach((entry, index) => {
          const topVal = entry.intersectionRect.top
          if (topVal > 0) {
            intersections.push(index)
            status.push(index)
          }
          else status.push(-1)
        });

        const indexOfElementIntersecting = intersections.length ? Math.min(...intersections) : Math.max(...status)

        setCurrentIntersectingElementIndex(indexOfElementIntersecting);
        //setScrollSpyIndex(currentIntersectingElementIndex)
		setScrollSpyIndex(indexOfElementIntersecting);  
      },
      {
        //root: //(typeof root === 'function' ? root() : root) || null,
        // use this option to handle custom offset
        rootMargin,
        threshold: IntersectionObserver.thresholds
      }
    )

    const { current: ourObserver } = observer
    const elements = targetIds.map((id) => document.querySelector(`#${id}`)) || []
    // observe all the elements passed as argument of the hook
    elements.forEach((element) =>
      element ? ourObserver.observe(element) : null
    )

    return () => ourObserver.disconnect()
  }, [currentIntersectingElementIndex, offset, root, rootMargin, setScrollSpyIndex, targetIds])

  return [currentIntersectingElementIndex]
}